import { UnhandledRejection } from './constants';
export var hookLifeCycles = function (lifeCycleConfigFunction, methods, wrapFn) {
    return function (config) {
        methods.forEach(function (method) {
            var originalHandler = config[method];
            config[method] = wrapFn(method, originalHandler);
        });
        return lifeCycleConfigFunction(config);
    };
};
export var hookComponentLifeCycles = function (lifeCycleConfigFunction, methods, wrapFn) {
    return function (config) {
        if (!config.methods) {
            config.methods = {};
        }
        methods.forEach(function (method) {
            var originalHandler = config.methods[method];
            config.methods[method] = wrapFn(method, originalHandler);
        });
        return lifeCycleConfigFunction(config);
    };
};
export var hookObjectMethods = function (target, methods, wrapFn) {
    methods.forEach(function (method) {
        if (target[method]) {
            var originalHandler = target[method];
            Object.defineProperty(target, method, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: wrapFn(method, originalHandler).bind(target),
            });
        }
    });
};
var unknown = 'unknown';
export var getHostPlatform = function () {
    if (typeof wx !== 'undefined') {
        return 'wx';
    }
    if (typeof tt !== 'undefined') {
        return 'tt';
    }
    if (typeof my !== 'undefined') {
        return 'my';
    }
    if (typeof swan !== 'undefined') {
        return 'swan';
    }
    return unknown;
};
// 目前没有用，之后在真机调试后再改
export var getGlobal = function () {
    // 小程序模拟器环境中有 global 对象但是是空对象
    // 所以要检测全局属性是否挂在 global 上来判断“真 global”对象，便于之后 hook
    if (typeof globalThis !== undefined && console === globalThis.console) {
        return globalThis;
    }
    if (typeof global !== undefined && console === global.console) {
        return global;
    }
    if (typeof window !== undefined && console === window.console) {
        return window;
    }
};
export var getDummyEnvInfo = function () {
    return {
        host_platform: getHostPlatform(),
        host_app_name: unknown,
        host_app_version: unknown,
        platform: unknown,
        sdk_version: unknown,
        os_name: unknown,
        os_version: unknown,
        device_brand: unknown,
        device_model: unknown,
        screen_height: 0,
        screen_width: 0,
        resolution: unknown,
        pixel_ratio: 0,
        network_type: unknown,
    };
};
export var getPid = function () {
    var pages = getCurrentPages();
    return pages[pages.length - 1].route;
};
export var makeError = function (errorString) {
    /**
      Mac 模拟器上报
      MiniProgramError
      options.reason.split is not a function
      TypeError: options.reason.split is not a function
          at EA.<anonymous> (http://127.0.0.1:44365/appservice/index.cjs.js:319:54)
          at EA.config.<computed> (http://127.0.0.1:44365/appservice/index.cjs.js:179:24)
          at EA.<anonymous> (http://127.0.0.1:44365/appservice/__dev__/WAService.js:2:3210959)
          at C (http://127.0.0.1:44365/appservice/__dev__/WAService.js:2:121167)
          at i.<anonymous> (http://127.0.0.1:44365/appservice/__dev__/WAService.js:2:121992)
          at i.emit (http://127.0.0.1:44365/appservice/__dev__/WAService.js:2:1617315)
          at Object.emit (http://127.0.0.1:44365/appservice/__dev__/WAService.js:2:1573801)
          at http://127.0.0.1:44365/appservice/__dev__/WAService.js:2:1611894
          at Function.<anonymous> (http://127.0.0.1:44365/appservice/__dev__/WAService.js:2:139971)
          at C (http://127.0.0.1:44365/appservice/__dev__/WAService.js:2:121167)
      iOS 真机上报
      MiniProgramError
      sync error
          at triggerSyncError (app-service.js:1179:327)
          at<setTimeout callback function>
          at (WASubContext.js:2:112386)
          at s (WASubContext.js:2:112386)
          ...
          global code
      MiniProgramError
      async error
          at (app-service.js:1179:327)
          at<setTimeout callback function>
          at (WASubContext.js:2:112386)
          ...
          _onNativeTimer
          global code
     */
    var errData = errorString.split('\n');
    return {
        name: errData[0],
        message: errData[1],
        stack: errData.slice(1).join('\n'),
        rawMessage: errorString,
    };
};
export var makeErrorFromRejection = function (_a) {
    var promise = _a.promise, reason = _a.reason;
    /**
     Mac 模拟器上报
      reject an error:
      Error: xxx
          at Function.<anonymous> (app.js? [sm]:16)
          at C (VM317 WAService.js:2)
          at VM317 WAService.js:2
          at VM317 WAService.js:2
      reject a value:
      3
      iOS 真机上报
      reject an error
      <Error: syn rejection with Error>
      reject a string:
      sync rejection with Error
     */
    var reasonString = String(reason);
    return promise.catch(function (error) {
        return {
            name: UnhandledRejection,
            message: String(error),
            stack: (error === null || error === void 0 ? void 0 : error.stack) || '',
            rawMessage: reasonString,
        };
    });
};
//# sourceMappingURL=utils.js.map